import * as yup from 'yup';
import { commentSchema } from 'utils/schemas/comment.schema';

export const COMMENT_MAX_LENGTH = 800;

export const schema = yup.object().shape({
  comment: commentSchema.required('validationErrors.comment.min'),
});
